/**
 * @generated SignedSource<<3f7c4169628b7133362e6af2ad8a3df9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useItemMediaItems_viewInRoomPhotos$data = ReadonlyArray<{
  readonly __typename: "viewInRoomPhotos";
  readonly credits: string | null;
  readonly src: string | null;
  readonly " $fragmentType": "useItemMediaItems_viewInRoomPhotos";
}>;
export type useItemMediaItems_viewInRoomPhotos$key = ReadonlyArray<{
  readonly " $data"?: useItemMediaItems_viewInRoomPhotos$data;
  readonly " $fragmentSpreads": FragmentRefs<"useItemMediaItems_viewInRoomPhotos">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useItemMediaItems_viewInRoomPhotos",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "src",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "credits",
      "storageKey": null
    }
  ],
  "type": "viewInRoomPhotos",
  "abstractKey": null
};

(node as any).hash = "54673871bc70d9b7505cda99466bbeaa";

export default node;
